export const COVA_HUB_PRODUCT_URL = 'https://hub.covasoft.net/#CatalogManager/products'

export interface FilterOption {
  value: string
  label: string
}

// Shared by the filter popovers and the "Selected filters" chips so both read
// the same text. Empty value = "no filter" and is never rendered as a chip.
export const STOCK_FILTER_OPTIONS: FilterOption[] = [
  { value: 'in', label: 'In Stock' },
  { value: 'out', label: 'Out of Stock' },
]

export const DATA_SOURCE_FILTER_OPTIONS: FilterOption[] = [
  { value: 'disconnect', label: 'Manually edited' },
  { value: 'syncing', label: 'POS Synced' },
]

export const MAPPING_FILTER_OPTIONS: FilterOption[] = [
  { value: 'mapped', label: 'Mapped' },
  { value: 'unmapped', label: 'Unmapped' },
]

// Specification hues from the ACD-15223 mockup that have no @pantry/ui token.
// Cannabinoid dots are shared by the spec table, the variant chips and the
// "+ Add field" menu; `diff*` colour the ◆ lines where a custom variant
// differs from the default variant.
export const specColors = {
  cannabinoid: {
    THC: '#10B981',
    CBD: '#3B82F6',
    CBN: '#8B5CF6',
    CBG: '#F59E0B',
  },
  diffText: '#6D28D9',
  diffMark: '#8B5CF6',
  diffSeparator: '#C4B5FD',
  diffAdded: '#047857',
  diffRemoved: '#B91C1C',
  purpleBorder: '#DDD6FE',
  purpleSoft: '#FAF5FF',
  purpleHover: '#EDE9FE',
  cardHeaderBg: '#FAFAFB',
  // "N variants customized" banner text, default-variant note text, row flash ring.
  bannerText: '#4C1D95',
  defaultNoteText: '#1E3A8A',
  flashRing: '#C4B5FD',
} as const

// Client caps matching the backend serializer limits (be_libs/utils/pantry_product.py),
// so the save never hits a nested 400 the UI can't show.
export const MAX_TERPENES = 30
export const MAX_EFFECTS = 50
export const MAX_FLAVOURS = 50
export const MAX_CUSTOM_SPECS = 50
export const MAX_CUSTOM_SPEC_LIST_ITEMS = 50
export const MAX_CUSTOM_SPEC_LIST_ITEM_LENGTH = 200
